import AdvancedSearch from "@/views/AdvancedSearch.vue";
import AllQueries from "@/views/AllQueries.vue";
import FullVisualization from "@/views/FullVisualization.vue";
import Home from "@/views/Home.vue";
import QueryByFeature from "@/views/QueryByFeature.vue";
import QueryByInference from "@/views/QueryByInference.vue";
import QueryByMention from "@/views/QueryByMention.vue";
import QueryDetail from "@/views/QueryDetail.vue";
import Summary from "@/views/Summary.vue";
//import { getAuth } from "firebase/auth";
import { createRouter, createWebHistory } from "vue-router";

//const auth = getAuth();

const routes = [
  // { path: "/login", name: "Login", component: SignInForm },
  // { path: "/signup", name: "SignUp", component: SignUpForm },
  { path: "/", name: "Home", component: Home },
  {
    path: "/query/:id",
    name: "QueryDetail",
    component: QueryDetail,
  },
  {
    path: "/visualization",
    name: "VisualizationPage",
    component: FullVisualization,
  },
  {
    path: "/queries",
    name: "AllQueries",
    component: AllQueries,
  },
  {
    path: "/queries-by-mention",
    name: "QueryByMention",
    component: QueryByMention,
  },
  {
    path: "/queries-by-feature",
    name: "QueryByFeature",
    component: QueryByFeature,
  },
  {
    path: "/queries-by-inference",
    name: "QueryByInference",
    component: QueryByInference,
  },
  {
    path: "/advanced-search",
    name: "AdvancedSearch",
    component: AdvancedSearch,
  },
  {
    path: "/summary",
    name: "Summary",
    component: Summary,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Scroll to top for new route navigation
    if (savedPosition) {
      return savedPosition; // For back/forward navigation
    } else {
      return { top: 0 }; // Always scroll to top
    }
  },
});

// router.beforeEach((to, from, next) => {
//   const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
//   const user = auth.currentUser;

//   if (requiresAuth && !user) {
//     next("/login");
//   } else if ((to.path === "/login" || to.path === "/signup") && user) {
//     next("/");
//   } else {
//     next();
//   }
// });

export default router;
